import { SITE_URL } from '@/constants/constants';
const SignOutButton = () => import('../../components/sign-out-button/index.vue');
const PrivacyPolicyModal = () => import('../../components/privacy-policy/index.vue');

export default {
    name: 'AccountPage',

    components: {
        'sign-out-button': SignOutButton
    },
    
    data() {
        const menuConfig = {
            menu: [
                {
                    detail: false,
                    button: true,
                    text: 'Profile',
                    url: '/account/profile'
                }, 
                {
                    detail: false,
                    button: true,
                    text: 'Buildings',
                    url: '/account/subscriptions'
                },
                {
                    detail: false,
                    button: true,
                    text: 'Sync',
                    url: '/account/storage-sync'
                },
                {
                    detail: false,
                    button: true,
                    text: 'Privacy Policy', 
                    url: `${SITE_URL}/privacy-policy`
                }
            ],
            
            base_url: SITE_URL
        }

        if (this.$store.state.subscriptions.active_subscription.role === 6) {
            menuConfig.menu = menuConfig.menu.filter(item => item.text !== 'Sync');
        }

        return menuConfig;
    },

    methods: {
        async navigateExternal(url) {
              //window.open(url, '_blank');
             // this.$router.push({ path: '/iframe', query: { externalUrl: url } });
             const privacyPolicyModal = await this.$ionic.modalController.create({
                 component: PrivacyPolicyModal,
                 backdropDismiss: false
             });
 
             privacyPolicyModal.present();
         }
     },

    created() {
        this.$store.commit('setMenuItems', this.menu);
        this.$store.commit('setMenuDetails', { title: 'Account', slug: 'account' });
        this.$store.commit('resetMessage');
        this.$store.commit('resetSearch');
    }
};